import { Component, ElementRef, OnInit, AfterViewInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription, fromEvent } from 'rxjs';
import { ApiService } from 'src/app/_service/api.service';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import { DeleteService } from 'src/app/_service/delete.service';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { TVNavigationService } from 'src/app/_service/tv-navigation.service';
import { TVFocusMemoryService } from 'src/app/_service/tv-focus-memory.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { URLS } from 'src/app/constants/URLS';
import { CATEGORIES } from 'src/app/constants/category';

@Component({
  selector: 'app-cc-prime-main',
  templateUrl: './cc-prime-main.component.html',
  styleUrls: ['./cc-prime-main.component.css']
})
export class CcPrimeMainComponent implements OnInit, AfterViewInit, OnDestroy {
  /** Snapshot of the component's route — see category-movie for rationale. */
  private componentRoute: string = '';

  @ViewChild('categoriesContainer') categoriesContainer!: ElementRef;
  @ViewChild('container') container!: ElementRef;
  @ViewChild('categoriesWrapper') categoriesWrapper!: ElementRef;

  serverDown:boolean = false;
  categories:any[] = [];
  contents:any[] = [];
  filteredContents:any;
  successMessage:string = '';
  isLoading:boolean = false;
  start_index:number = 0;
  last_index:number = 3;
  skeletonCount:number;
  resizeSubscription:Subscription;
  lastScrollTop = 0;
  categoriesVisible = true;
  scrollThreshold = 100;
  activeCategory = '';
  showScrollButtons = false;

  constructor(
    private router: Router,
    private authService: AuthenticateserviceService,
    private el:ElementRef,
    private watchlistService: DeleteService,
    private toasterService: ToastrService,
    private mycontentService: MycontentserviceService,
    private apiService: ApiService,
    private whitelabelService: WhiteLabelService,
    private tvNav: TVNavigationService,
    private focusMemory: TVFocusMemoryService,
    private deviceService: DeviceService
  ) {
    this.contents
   }

  ngOnInit(): void {
    this.getCcPrimeContent();
    this.calculateSkeletons();
    this.setupIntersectionObserver();
    this.checkScrollButtonsVisibility();
  }

  ngAfterViewInit(): void {
    if (this.deviceService.isTV()) {
      this.componentRoute = this.router.url;
      setTimeout(() => {
        this.restoreTvFocus();
      }, 200);
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.checkScrollButtonsVisibility();
  }

  checkScrollButtonsVisibility() {
    setTimeout(() => {
      if (this.categoriesContainer) {
        const container = this.categoriesContainer.nativeElement;
        const hasOverflow = container.scrollWidth > container.clientWidth;
        this.showScrollButtons = hasOverflow;
      }
    }, 100);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    this.categoriesVisible = true;
  }

  setupIntersectionObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const categoryName = entry.target.getAttribute('categoryName');
          if (categoryName) {
            this.activeCategory = categoryName;
          }
        }
      });
    }, {
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0.1
    });
    setTimeout(() => {
      const categoryElements = this.el.nativeElement.querySelectorAll('[categoryName]');
      categoryElements.forEach(el => observer.observe(el));
    }, 1000);
  }

  scrollToCategory(categoryName:string){
    const categoryElement = this.el.nativeElement.querySelector(`[categoryName="${categoryName}"]`);
    if (categoryElement) {
      this.categoriesVisible = true;
      const headerOffset = 120;
      const elementPosition = categoryElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  scrollCategories(direction: number){
    const container = this.categoriesContainer.nativeElement as HTMLElement;
    container.scrollBy({
      left: direction * 200,
      behavior: 'smooth'
    })
  }

  calculateSkeletons() {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1920) {
      this.skeletonCount = 15;
    } else if (screenWidth >= 1440) {
      this.skeletonCount = 12;
    } else if (screenWidth >= 1024) {
      this.skeletonCount = 8;
    } else if (screenWidth >= 768) {
      this.skeletonCount = 6;
    } else{
      this.skeletonCount = 5;
    }
  }
  
  transformedVideo:any[]

  getCcPrimeContent(){
    this.isLoading = true;
    this.apiService.get(`${URLS.getCcPrimeVideoLibrary}?start_index=${this.start_index}&last_index=${this.last_index}&video_type=premium`).subscribe((result:any)=>{
      this.contents = result.data || [];
      this.categories = this.contents.map(item => ({
        id: item.categoryId,
        name: item.categoryName
      }));
      this.mapVideoData();
      this.mapwatchContent();
      console.log(this.contents)
      this.isLoading = false;
      this.checkScrollButtonsVisibility();
    },(error)=>{
      this.isLoading = false;
      console.log(error);
      if(error?.statusText === 'Unknown Error'){
        this.serverDown = !this.serverDown;
      }
    })
  }

  mapVideoData(){
    this.contents.map(section =>{
      if (Array.isArray(section.category_data)) {
        this.mycontentService.transformcCPrimeData(section); 
      }
    })
  }

  mapwatchContent() {
    const usrId = localStorage.getItem('userId');
    this.mycontentService.getWatchListOfUser(usrId).subscribe((watchresult) => {
      this.contents.forEach((section) => {
        if (Array.isArray(section.category_data)) {
          section.category_data.forEach((category) => {
            category.isInWatchList = watchresult.some(
              (wlitem) => category.vidLibId === wlitem.vidLibId
            );
          });
        }
      });
    });
    this.isLoading = false;
  }

  ngOnDestroy(){
    if(this.resizeSubscription){
      this.resizeSubscription.unsubscribe();
    }

    // Save focus position for TV mode
    if (this.deviceService.isTV()) {
      const regionId = this.tvNav.getActiveRegionId();
      const index = this.tvNav.getFocusedIndex();
      if (regionId) {
        this.focusMemory.saveFocusPosition({
          regionId,
          index,
          timestamp: Date.now(),
          route: this.componentRoute
        });
      }
    }
  }

  openCategoryPage(content:any){
    const route = this.whitelabelService.getPrefixedRoute('category');
    this.router.navigate([route], {
      queryParams: { id: content.categoryId, no: content.video_count }
    });
  }

  openVideoPlayer(vidLibId: number): void {
    const route = this.whitelabelService.getPrefixedRoute('watch');
    this.router.navigate([route], {
      queryParams: { ref: vidLibId }
    });
  }

  stopPropagation(event:Event){
    event.stopPropagation();
  }

  addInWatchList(videoDetails:any) {
    if(!videoDetails.isEnable){
      this.watchlistService.addToWatchlist(videoDetails);
      this.toasterService.success('Added to watchlist', 'Success');
    }
  }

  private restoreTvFocus(): void {
    // Priority: lastContentFocus (sidebar switch) > focus memory (route return) > default
    if (this.tvNav.hasLastContentFocus()) {
      return; // TVNavigationService handles sidebar-to-content restoration
    }

    const saved = this.focusMemory.restoreFocusPosition(this.router.url);
    if (saved) {
      this.tvNav.activateRegion(saved.regionId, saved.index);
    }
    // If no saved position, TVNavigationService auto-focuses first region via registerRegion()
  }
}